import { render, staticRenderFns } from "./catalogueList.vue?vue&type=template&id=34e0ff63&"
import script from "./catalogueList.vue?vue&type=script&lang=js&"
export * from "./catalogueList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports